import {
  REQUEST_CATEGORY_PARENT_LIST,
  REQUEST_CATEGORY_LIST,
  REQUEST_CATEGORY_LIST_FOR_CREATE,
} from './mutation-types'

export default {
  [REQUEST_CATEGORY_PARENT_LIST](state, receivedData) {
    state.categoryParentList = receivedData
  },
  [REQUEST_CATEGORY_LIST](state, receivedData) {
    state.categoryList = receivedData.content
    state.categoryListCount = receivedData.totalElements
  },
  [REQUEST_CATEGORY_LIST_FOR_CREATE](state, receivedData) {
    state.categoryListForCreate = receivedData
  },
}